import ComponentRow from "./ComponentRow";

export default ComponentRow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ComponentRow/index.tsx